import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// Two surfaces from one build: the tabbed app, and the always-on Control
// Center (at /control, or at / when built with VITE_APP_MODE=control for its
// own Pages project). Each is its own chunk so the kiosk loads only what it runs.
const controlMode =
  import.meta.env.VITE_APP_MODE === 'control' || window.location.pathname.replace(/\/+$/, '') === '/control';

const Root = controlMode ? lazy(() => import('./control/ControlApp')) : lazy(() => import('./App'));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>
      <Root />
    </Suspense>
  </StrictMode>,
);
